export default __webpack_public_path__ + "static/media/welcome-tour-1.48aa5893.png";